
define('app/board/models/draftStatusModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var DraftStatusModel = Backbone.Model.extend({	
		defaults: {
			id: null, //Just the lgInstId
			draftingTeamId: null,
			round: null,
			posInRound: null,
			draftType: null,
			completed: false,
			demo: false,
			auctionBidding: false,
			auctionPickId: null,
			auctionWinningTeamId: null,
			auctionBidValue: 0,
			auctionBidPlayerId: null,
			
			auctionManualPlayerPos : null,
			auctionManualPlayerByeWeek : 0,
			auctionManualPlayerTeamAbbr : null,
			auctionManualPlayerFirstName : null,
			auctionManualPlayerLastName : null,
			
			teamPosMap: {},// fantTeamId : {lgPosId : [PosRoundId]} // how many draft players there are in each position
			teamPickCount: {}, // fantTeamId : numPicks // how many picks a team has made
			teamMinPosRequired: {}, // fantTeamId : boolean // whether that team is required to pick from positions whose min hasn't been met
			teamMaxedPositions: {}, // fantTeamId : [posType] // which positions the team has maxed out
			allowedPositions: {},  // fantTeamId : [posType] // which positions are allowed
			teamMaxNumPicks: {}, // fantTeamId : numPicks // how many total picks a team has this draft
			teamBudget: {} // fantTeamId : budget
			
			
	    },

	    initialize: function() {
	    	
	    },
	});
	
	
	return DraftStatusModel;  
});